import { useSearchParams } from 'react-router';
import { useMe } from '../lib/session';
import { ErrorNotice, Notice } from '../ui/feedback';
import { PortalLayout } from './PortalLayout';
import { AccountSection, DeleteAccountSection, DevicesSection, DiscordSection, LoginSection, WEB_COMMAND } from './sections';

/** Startseite des Portals (Revision R1); auch Ziel von `/login?error=…`. */
export function HomePage() {
  const me = useMe();
  const [params] = useSearchParams();

  return (
    <PortalLayout>
      {me.isPending && <p className="muted">Lädt…</p>}
      {me.isError && <ErrorNotice error={me.error} onRetry={() => me.refetch()} />}
      {me.data === null && <LoginSection error={params.get('error')} returnTo="/" />}
      {me.data && (
        <>
          <section>
            <h1>Hallo {me.data.name ?? ''}</h1>
            {params.get('discord') === 'linked' && <Notice tone="info">Discord ist verknüpft.</Notice>}
            {me.data.status === 'suspended' && (
              <Notice>Dein Konto ist gesperrt. Die Mod funktioniert nicht mehr. Wende dich an die Admins.</Notice>
            )}
            {me.data.status === 'pending_beta' && (
              <Notice tone="warn">
                <span>
                  Melde dich einmal im Spiel an (<span className="mono">{WEB_COMMAND}</span>), dann ist dein Konto freigeschaltet.
                </span>
              </Notice>
            )}
            {me.data.status === 'active' && <p className="lead">Suche und Teams findest du in der Mod.</p>}
          </section>
          <AccountSection me={me.data} />
          <DevicesSection />
          <DiscordSection me={me.data} />
          <DeleteAccountSection />
        </>
      )}
    </PortalLayout>
  );
}
